import { toast } from 'react-toastify';
import { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import validator from 'validator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

export default function Register({setCurrentUser}) {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
	const navigate = useNavigate ();

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  }

  const handleChangePassword = (e) => {
    let passVal = e.target.value;
    let nbErrors = 0;
    setPassword(passVal);

    if (passVal.length >= 8) {
      document.getElementById('li1').className = 'green';
    }
    else {
      document.getElementById('li1').className = 'red';
      nbErrors++;
    }

    if (passVal.match(/[A-Z]/, 'g')) {
      document.getElementById('li2').className = 'green';
    }
    else {
      document.getElementById('li2').className = 'red';
      nbErrors++;
    }

    if (passVal.match(/[a-z]/, 'g')) {
      document.getElementById('li3').className = 'green';
    }
    else {
      document.getElementById('li3').className = 'red';
      nbErrors++;
    }

    if (passVal.match(/[0-9]/, 'g')) {
      document.getElementById('li4').className = 'green';
    }
    else {
      document.getElementById('li4').className = 'red';
      nbErrors++;
    }

    if (passVal.match(/[.,?!:$@*-+=&#()\[\]]/, 'g')) {
      document.getElementById('li5').className = 'green';
    }
    else {
      document.getElementById('li5').className = 'red';
      nbErrors++;
    }

    if (nbErrors === 0) {
      document.getElementById('btn_submit').disabled = false;
    }
    else {
      document.getElementById('btn_submit').disabled = true;
    }
  }

  const handleSubmit = (e) => {
    // Prevent the browser from reloading the page
    e.preventDefault();

    // Get the form data
    const form = e.target;
    const formData = new FormData(form);
    const formJson = JSON.stringify(Object.fromEntries(formData.entries()));

    if (validator.isEmail(form.email.value)) {
      if (validator.isStrongPassword(form.password.value)) {
        // Send to API
        loginExists(formJson);
      }
      else {
        toast.error((<div>Le mot de passe est invalide, veuillez le modifier : <ul className="small">
            <li>Longueur minimale : 8</li>
            <li>Au moins une majuscule</li>
            <li>Au moins une minuscule</li>
            <li>Au moins un nombre</li>
            <li>Au moins un symbole parmi .,?!:$@*-+=&#()[]</li>
          </ul></div>), {
          autoClose: 5000,
        });
      }
    }
    else {
      toast.error('L\'email est invalide, veuillez le modifier.', {
        autoClose: 2000,
      });
    }
  }

  // Test email
  async function loginExists(dataJson) { 
    await fetch(process.env.REACT_APP_API_SERVER + '/api/auth/logincheck', {
      method: 'post', 
      headers: {'Content-Type': 'application/json'},
      body: dataJson
    })
    .then(response => response.json())
    .then((data) => {
      if (data.user) {
        toast.error('Cet email est déjà utilisé, veuillez vous connecter', {
          autoClose: 1000,
        });
      }
      else {
        register(dataJson);
      }
    });
    return;
  }

  // Save user in DB
  async function register(data) {
    await fetch(process.env.REACT_APP_API_SERVER + '/api/auth/register', { 
      method: 'post', 
      headers: {'Content-Type': 'application/json'},
      body: data 
    })
    .then(response => response.json())
    .then(data => confirmation(data));
    return;
  }

  // Display confirmation message
  const confirmation = (data) => {
    console.log(data);
    if (data.token) {
      toast.success('Inscription réussie 🎉', {
        autoClose: 1000,
        onClose: () => {
          navigate('/registered');
        }
      });
    }
    else {
			toast.error("Erreur de création du compte 😱", {
        autoClose: 1000
      });
      console.log("Erreur de creation");
    }
  }
    
	return(
		<>
			<h2>Créez un compte pour accéder au jeu</h2>
      <p>Ce compte vous permettra de sauvegarder vos scores.</p>

			<form method="post" onSubmit={handleSubmit}>
        <div className="field">
          <label htmlFor="email">Email : </label>
          <input type="text" name="email" value={email} onChange={e => handleChangeEmail(e)} />
        </div>

        <div className="field">
          <label htmlFor="password">Password : </label>
          <input type={showPassword ? "text" : "password"} id="field_password" name="password" value={password} onChange={e => handleChangePassword(e)} />
          <button
            type="button"
            className="password-visibility-button"
            onClick={() => setShowPassword(!showPassword)}
            aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </button>

          <ul className='small red'>
            <li id='li1' className='red'>Longueur minimale : 8</li>
            <li id='li2' className='red'>Au moins une majuscule</li>
            <li id='li3' className='red'>Au moins une minuscule</li>
            <li id='li4' className='red'>Au moins un nombre</li>
            <li id='li5' className='red'>Au moins un symbole parmi .,?!:$@*-+=&#()[]</li>
          </ul>
        </div>

        <div className="field">
          <input type="submit" id="btn_submit" disabled value="Créer mon compte" />
        </div>
			</form>

      <p>Si vous avez déjà un compte, <Link to="/authent/login">connectez-vous</Link>.</p>
		</>
	);
}